import React from 'react';
import { PLAN_BENEFITS } from '../../data/woodworking';

/** Compact value bridge between the preview and the technical proof. */
export function PlanSection() {
  return <section aria-labelledby="plan-title" className="border-y border-ivory-line bg-ivory-deep py-14 text-ink sm:py-20" data-id="element-194" data-mp="16x2kguunkzac">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:items-end lg:gap-14" data-id="element-195" data-mp="1bwowx22nqbi3">
        <div className="lg:col-span-6" data-id="element-196" data-mp="f6phcno3acq0">
          <h2 id="plan-title" className="text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] text-ink min-[390px]:text-[1.95rem] sm:text-[2.45rem] lg:text-[2.6rem]" data-id="element-197" data-mp="f3tgorkux9xv">
            Start your next furniture build with a clear plan.
          </h2>
          <p className="mt-4 max-w-xl text-[1rem] leading-relaxed text-stone sm:text-[1.06rem]" data-id="element-198" data-mp="sz5mpv4gqmu3">
            Choose a project, review the dimensions and materials, identify the parts, and follow the illustrated
            assembly sequence—without designing every detail from scratch.
          </p>
        </div>

        <ol className="grid gap-0 sm:grid-cols-3 sm:border-t sm:border-olive lg:col-span-6" data-id="element-199" data-mp="1wyhh137a7iio">
          {PLAN_BENEFITS.map(benefit => <li key={benefit} className="relative border-l border-olive py-3 pl-5 sm:border-l-0 sm:pl-0 sm:pr-5 sm:pt-6" data-id="element-200" data-mp="1s6r6aw4fmsqq">
              <span className="absolute -left-[5px] top-[19px] h-[9px] w-[9px] rounded-full bg-forest sm:-top-[5px] sm:left-0" aria-hidden data-id="element-201" data-mp="1n8fu4eqo065c" />
              <p className="font-brand text-[1rem] font-bold uppercase leading-snug tracking-[0.02em] text-forest" data-id="element-202" data-mp="1d9qjn713lnz4">
                {benefit}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}